import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { TicketAnswerRequestModel } from '@/modules/ticket-answer/models/ticket-answer-request.model'
import { AdminTicketAnswerService } from '@/modules/ticket-answer/services/admin-ticket-answer.service'

@vservice()
export class TicketAnswerCreateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminTicketAnswerService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(ticketId: number, data: TicketAnswerRequestModel) {
    return this.service.store(ticketId, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

}
